<template>
  <div class="main">
    <transition name="slide-fade">
      <div class="top">
        <el-carousel
          indicator-position="none"
          height="100%"
          :interval="3000"
          arrow="never"
          trigger="never"
        >
          <el-carousel-item v-for="(item,index) in this.banner.mobile_img" :key="index">
            <div class="banner" :style=" 'background-image: url(' + item + ');'">
              <p class="bannerp1">{{bannertitle1}}</p>
              <p class="bannerp2">{{bannertitle2}}</p>
              <p class="bannerp2">{{bannertitle3}}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </transition>

    <div class="about">
      <p>{{aboutus}}</p>
      <div class="about-div">
        <div class="about-div2">
          <div class="aboutExplain">{{aboutusdesc}}</div>
          <router-link to="/mContact">
            <div class="more">
              {{aboutusmore}}
              <i class="el-icon-arrow-right"></i>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <div class="about about2">
      <p>{{cb}}</p>
      <div class="cooperation">
        <div v-for="item in 32" :key="item">
          <!-- <img :src="logoFlag == item ? require('../../assets/w/logo' + item + '.png') : require('../../assets/b/logo' + item + '.png')" @mouseenter="logoHover(item)" @mouseleave="logoFlag = -1" alt=""> -->
          <img :src="require('../../assets/dashu/a/' + item + '.png')" alt />
        </div>
      </div>
    </div>

    <div class="news">
      <p>
        {{news}}
        <span class="news-span">
          <router-link to="mSchool">
            <span>
              {{newsmore}}
              <i class="el-icon-arrow-right"></i>
            </span>
          </router-link>
        </span>
      </p>

      <div class="three">
        <div
          class="three1"
          @click="routerdetails0() "
          :style=" 'background-image: url(' + this.newarray[0].image + ');'"
        >
          <div class="newtitle2">
            <span
              class="newtitle-span1"
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[0].title:this.newarray[0].title_en}}</span>
            <span
              class="newtitle-span2"
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[0].introduce:this.newarray[0].introduce_en}}</span>
          </div>
        </div>
        <div
          class="three2"
          @click="routerdetails1() "
          :style=" 'background-image: url(' + this.newarray[1].image + ');'"
        >
          <div class="newtitle2">
            <span
              class="newtitle-span1"
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[1].title:this.newarray[1].title_en}}</span>
            <span
              class="newtitle-span2"
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[1].introduce:this.newarray[1].introduce_en}}</span>
          </div>
        </div>
        <div
          class="three3"
          @click="routerdetails2() "
          :style=" 'background-image: url(' + this.newarray[2].image + ');'"
        >
          <div class="newtitle2">
            <span
              class="newtitle-span1"
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[2].title:this.newarray[2].title_en}}</span>
            <span
              class="newtitle-span2"
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[2].introduce:this.newarray[2].introduce_en}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import animate from "animate.css";
export default {
  data() {
    return {
      // kakatopnum:0,
      logoFlag1: 0,
      logoFlag2: 0,
      logoFlag3: 0,
      navtop: 0,
      // title:'',
      bannerUrl: "",
      detail: "",
      banner: "",
      bannerb: true,
      show: true,
      newarray: [
        {
          title: ""
        },
        {
          title: ""
        },
        {
          title: ""
        }
      ],
      ischinese: "cn",
      bannertitle1: "大树联合集团",
      bannertitle2: "大树联合集团开创于2018年，主要从事",
      bannertitle3: "电子商务、设计、程序等互联网业务",
      aboutus: "关于我们",
      aboutusdesc:
        "专注以提供品牌电子商务为核心的一站式商业解决方案，涉及店铺运营、数字营销、IT解决方案、仓储配送、客户服务等五大内容",
      aboutusmore: "了解更多",
      news: "新闻中心",
      newsmore: "查看更多",
      cb: "合作品牌"
    };
  },
  methods: {
    showIcon() {
      // console.log(document.documentElement.scrollTop)
      // console.log(document.body.scrollTop)
      if (document.body.scrollTop === 0) {
        this.navtop = document.documentElement.scrollTop;
      } else {
        this.navtop = document.body.scrollTop;
      }

      if (document.documentElement.scrollTop > 1000) {
        this.navtop = 1000;
      }
      if (document.body.scrollTop > 1000) {
        this.navtop = 1000;
      }
    },
    routerdetails0() {
      this.$router.push({
        name: "mDetail",
        query: { detailsid: this.newarray[0].id }
      });
    },
    routerdetails1() {
      this.$router.push({
        name: "mDetail",
        query: { detailsid: this.newarray[1].id }
      });
    },
    routerdetails2() {
      this.$router.push({
        name: "mDetail",
        query: { detailsid: this.newarray[2].id }
      });
    }
  },
  created() {
    this.ischinese = window.localStorage.getItem("ischinese") || "cn";
    if (this.ischinese == "en") {
      this.bannertitle1 = "Dashu United Group";
      this.bannertitle2 =
        "Founded in 2018, Dashu united group is mainly engaged in ";
      this.bannertitle3 =
        "e-commerce, design, program and other Internet businesses";
      this.aboutus = "ABOUT US";
      this.aboutusdesc =
        "Focus on providing brand e-commerce as the core of one-stop business solutions, involving store operation, digital marketing, it solutions, warehousing and distribution, customer service, etc";
      this.aboutusmore = "Learn more";
      this.news = "News Center";
      this.newsmore = "View more";
      this.cb = "Cooperation brand";
    }

    this.$http
      .post("/api/dashu/index/bannerList", {})
      .then(res => {
        // console.log(res.data.data)
        var code = res.data.code;
        if (code === 0) {
          this.banner = res.data.data.banner;
          // console.log(this.banner)
          this.newarray = res.data.data.new;
          //  console.log(this.newarray)
        }
      })
      .catch(function(error) {
        //  console.log(error);
      });
  },
  mounted() {
    window.addEventListener("scroll", this.showIcon);
  }
};
</script>
<style scoped>
body {
  position: relative;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
.el-carousel--horizontal {
  overflow-x: hidden;
  height: 10.29rem;
}
.top {
  overflow: hidden !important;
  position: relative;
  background-repeat: no-repeat;
  width: 100%;
  height: 10.29rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.banner {
  overflow: hidden !important;
  position: relative;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  width: 100%;
  height: 10.29rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.about {
  overflow: hidden !important;
  position: relative;
  height: 4.3rem;
  padding: 0.9rem 0.4rem 0;
  text-align: center;
}
.about2 {
  overflow: hidden !important;
  position: relative;
  height: 4.4rem;
  padding: 0.9rem 0.4rem 0.9rem;
  text-align: center;
  background: rgb(237, 237, 237);
}
.about p {
  text-align: left;
  margin: 0 0 0.4rem 0;
  font-size: 0.48rem;
  font-weight: bold;
}
.about img {
  position: absolute;
  top: 35px;
  left: 20%;
}
.about-div {
}
.aboutExplain {
  text-align: left;
  color: #888888;
  font-size: 0.24rem;
  line-height: 0.44rem;
}
.more {
  background: #76c3a2;
  color: white;
  font-size: 0.24rem;
  line-height: 0.5rem;
  width: 2.05rem;
  height: 0.5rem;
  border-radius: 5px;
  position: absolute;
  bottom: 0.88rem;
  cursor: pointer;
}
.cooperation {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.cooperation div {
  position: relative;
  width: 0.73rem;
  height: 0.73rem;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0.05rem;
}
.cooperation div img {
  width: 0.73rem;
  height: 0.73rem;
  position: absolute;
  top: 0;
  left: 0;
}
.news {
  overflow: hidden !important;
  position: relative;
  height: 25.4rem;
  padding: 0.9rem 0.4rem 0;
}
.news p {
  text-align: left;
  margin: 0 0 0.4rem 0;
  font-size: 0.48rem;
  font-weight: bold;
}
.news img {
  position: absolute;
  top: 35px;
  left: 20%;
}
.news-span span {
  color: #888888;
  font-size: 0.24rem;
  line-height: 0.5rem;
  font-weight: 100;
  float: right;
}
.three {
  margin: 0.6rem 0 0;
}
.three1,
.three2,
.three3 {
  width: 6.7rem;
  height: 7.5rem;
  position: relative;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  box-shadow: 0px 0px 0.2rem #888888;
}
.three2 {
  margin: 0.3rem 0;
  /* background-image: url('../../assets/dashu/new2.png'); */
}
.newtitle {
  position: absolute;
  top: 0;
  padding: 5%;
  width: 90%;
  height: 85%;
  text-align: left;
  background: #888888;
  border-right: 1px solid #888888;
  opacity: 0.8;
}
.newtitle2 {
  position: absolute;
  bottom: 0;
  padding: 5%;
  width: 90%;
  text-align: left;
  background: #76c3a2;
  border-right: 1px solid #76c3a2;
  /* opacity: 0.8; */
}
.newtitle-span1 {
  text-align: left;
  font-size: 0.36rem;
  line-height: 0.44rem;
  font-weight: bold;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
}
.newtitle-span2 {
  text-align: left;
  font-size: 0.24rem;
  line-height: 0.44rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  margin-top: 0.25rem;
}
.bannerp1 {
  /* position: absolute;
  top: 230px;
  left: 400px; */
  text-align: center;
  font-size: 0.65rem;
  font-weight: bold;
  color: white;
  margin-top: 2rem;
}
.bannerp2 {
  /* margin: 0 auto; */
  font-size: 0.35rem;
  line-height: 1.5;
  width: 100%;
  /* width: 6.7rem; */
  /* -webkit-line-clamp: 2; */
  color: white;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/mbPages/mEnter.vue